import axios from 'axios';

// Configure axios defaults for CSRF protection
axios.defaults.xsrfCookieName = 'csrftoken';
axios.defaults.xsrfHeaderName = 'X-CSRFToken';
axios.defaults.withCredentials = true;

// Add response interceptor to handle 401/403 errors
axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Unauthorized - redirect to login
      if (window.location.pathname !== '/conduct0r' &&
          !window.location.pathname.startsWith('/respond/') &&
          !window.location.pathname.startsWith('/r/')) {
        window.location.href = '/';
      }
    } else if (error.response?.status === 403) {
      // Forbidden - CSRF error or permission denied
      console.error('Permission denied or CSRF token invalid');
    }
    return Promise.reject(error);
  }
);

export default axios;
